<mat-list-item class="title-type">
  <div class="wrapper">
    <div class="fieldName m-12">{{attribute.attr.name}}</div>
  </div>
</mat-list-item>

